export const PRINT_STYLE_ID = 'wrapper-label-print-style';
export const PRINT_HOST_ID = 'wrapper-label-print-host';
const PRINT_AREA_SELECTOR = '.print-page-content-wrapper-paper';

export function printLabels() {
  const printArea = document.querySelector<HTMLElement>(PRINT_AREA_SELECTOR);
  const host = document.getElementById(PRINT_HOST_ID);

  if (!printArea || !host) {
    console.warn(
      'Nao foi possivel preparar a impressao: area ou host de impressao nao encontrados.',
    );
    return;
  }

  const originalParent = printArea.parentNode;
  const originalNextSibling = printArea.nextSibling;

  const handleBeforePrint = () => {
    host.appendChild(printArea);
  };

  const handleAfterPrint = () => {
    if (originalParent) {
      originalParent.insertBefore(printArea, originalNextSibling);
    }
    window.removeEventListener('beforeprint', handleBeforePrint);
    window.removeEventListener('afterprint', handleAfterPrint);
  };

  window.addEventListener('beforeprint', handleBeforePrint);
  window.addEventListener('afterprint', handleAfterPrint);

  window.print();
}
